import React from "react";

export const PrivacyPolicy = () => {
  return (
      <>
        <h3>Privacy policy</h3>
        <p>We use Google Analytics and Google Optimize for aggregated, anonymized website traffic analysis. In order to track your session
        usage, Google drops a cookie (<em>_ga</em> / <em>_gaexp</em>) with a randomly-generated ClientID in your browser. This ID is anonymized and
        contains no identifiable information like email, phone number, name, etc. We also send Google your IP Address.
        We use GA to track aggregated website behavior, such as what pages you looked at, for how long, and so on.
        This information is important to us for improving the user experience and determining site effectiveness.
        If you would like to access what browsing information we have - or ask us to delete any GA data - please delete
        your <em>_ga</em> / <em>_gaexp</em> cookies, and/or install
        the <a href="https://tools.google.com/dlpage/gaoptout">Google Analytics Opt-Out Browser Add-On</a>.</p>
      </>
  );
}
